module.exports = __webpack_public_path__ + "static/merrow-06a9bbfe8634f03d2754682a642130fd.jpg";